import i18n from '@libs/i18n'

import { IFilter as IFilterDrawerFilter } from '@components/FilterDrawer'
import { IItem } from '@components/Select'

import StringUtils from '@utils/strings'

import { IFilter } from './types'

interface IDataColumn {
  field: string
  filter: string
  display: string
}

const t = i18n.t.bind(i18n)

export const getItemsFromEnum = (
  _enum: { [s: string]: string },
  customGetLabel?: (v: string) => string
): {
  label: string
  value: string
}[] =>
  Object.values(_enum).map((enumVal: string) => {
    return {
      label: customGetLabel
        ? customGetLabel(enumVal) ?? ''
        : t(StringUtils.capitalizeWords(enumVal)),
      value: enumVal,
    }
  })

export const getLabelFromItem = ({
  items,
  value,
}: {
  items: { label: string; value: string }[]
  value?: string
}): string => {
  const foundItem = items.find((v) => v.value === value)

  return foundItem ? t(foundItem.label) : 'N/A'
}

export const getLabelFromEnumValue = (value: string | undefined) => {
  const formatValue = (value: string) =>
    value
      .split('-')
      .map((x) => x[0].toUpperCase() + x.slice(1))
      .join(' ')
  return value ? formatValue(value) : undefined
}

export const getFilterFields = ({
  searchParams,
  paramsToIgnore = ['page', 'limit'],
}: {
  searchParams: URLSearchParams
  paramsToIgnore?: string[]
}) => {
  const filters: IFilter[] = []

  for (const [key, value] of searchParams) {
    if (paramsToIgnore.includes(key)) {
      continue
    }

    const alreadyExists = filters?.find(({ field }) => field === key)

    if (alreadyExists && value?.length > 0) {
      alreadyExists.value = [...alreadyExists.value, value]
      continue
    }

    filters.push({
      field: key,
      value,
    })
  }

  return filters
}

export const createDrawerFilters = ({
  drawerFilters,
}: {
  drawerFilters: (Omit<IFilterDrawerFilter, 'name' | 'label'> & {
    column: IDataColumn
    items?: IItem[]
  })[]
}) =>
  drawerFilters.map((drawerFilter) => {
    const { column, items } = drawerFilter

    return {
      ...drawerFilter,
      name: column.filter,
      label: t(column.display),
      items,
    }
  })

export default {
  getItemsFromEnum,
  getLabelFromItem,
  getLabelFromEnumValue,
  getFilterFields,
  createDrawerFilters,
}
